<template>
   <v-container fluid> 
        <QueryBuilder v-show="toggle_mode==0" ref="queryBuilder" v-on:run="executeQuery($event)"/>
        <DataViewer v-show="toggle_mode==1" ref="dataViewer" v-on:design="toggle_mode=0" />
    </v-container>
</template>

<script> 

import QueryBuilder from "./qb/QueryBuilder";
import DataViewer from "./qb/DataViewer";

export default {
  name: 'QBModule',
  components: { 
    QueryBuilder,DataViewer
  },
  
  data() {
      return {
        toggle_mode: 0,
      }
  },
   methods: {
    executeQuery(query) {
        this.toggle_mode=1;
        this.$nextTick(() => {
          this.$refs.dataViewer.executeQuery(query);
        });
    },
    onReveal() {
        this.toggle_mode=0;
        this.$refs.queryBuilder.onReveal();
    }
   }
};
</script>
